import { Pagination } from './styles'
import { Button, TextField } from '@material-ui/core'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import Skeleton from '@material-ui/lab/Skeleton';
import { semNumeroNegativoInput } from '../../../utils/semNumeroNegativoInput';
import { OficioBox } from '../../data_display/OficioBox/styles';

export default function PaginationComponent({
    loading,
    pagina,
    setPagina,
    paginaAtual,
    setPaginaAtual,
    totalPaginas,
    itensPorPagina,
    comtemTitulo
}) {
    const handleNavigation = type => {
        if (type === 'anterior') {
            setPagina(Number(pagina) - 1)
        }
        else if (type === 'proximo') {
            setPagina(Number(pagina) + 1)
        }
    }

    return (
        <Pagination id="Pagination">
            {
                loading
                    ?
                    <Skeleton id="skeleton-pagination" animation="wave" />
                    :
                    <>
                        <OficioBox.FixedTitle id="OficioBox_FixedTitle" style={{ visibility: comtemTitulo ? 'visible' : 'hidden' }}>Ofícios</OficioBox.FixedTitle>
                        <Pagination.Controls id="Pagination_Controls">
                            <span>Página</span>
                            <TextField
                                id="outlined-basic"
                                variant="outlined"
                                value={paginaAtual}
                                type="number"
                                disabled={pagina === totalPaginas ? true : false}
                                onChange={event => {
                                    if (event.target.value > 0) {
                                        if (event.target.value <= totalPaginas) {
                                            semNumeroNegativoInput(event, setPagina)
                                        }
                                    }
                                }}
                            />
                            <span>de {totalPaginas}</span>
                            <Button
                                className="btn-action-pagination"
                                disabled={pagina === 1 ? true : false}
                                onClick={() => handleNavigation('anterior')}
                            >
                                <ChevronLeftIcon />
                            </Button>

                            <Button
                                className="btn-action-pagination"
                                disabled={pagina === totalPaginas ? true : false}
                                onClick={() => handleNavigation('proximo')}
                            >
                                <ChevronRightIcon />
                            </Button>
                        </Pagination.Controls>
                    </>
            }
        </Pagination>
    )
}